export default "__VITE_ASSET__B$kf$Yvo__$_?url__"